export default __webpack_public_path__ + "static/cynthiaSCA-7eaf589c72d4ed0a8ca7cf050adf511a.webp";